import React from 'react';
import './PaymentMethodItem.css';

/**
 * PaymentMethodItem Component
 *
 * Displays a single payment method option with icon, title, and selection state
 *
 * @param {Object} props
 * @param {Object} props.method - Payment method object with { bic, title, img_url, payment_type }
 * @param {boolean} props.isSelected - Whether this payment method is currently selected
 * @param {Function} props.onSelect - Callback when payment method is selected
 * @param {boolean} props.disabled - Whether the payment method is disabled
 * @param {string} props.cartType - Type of cart (normal or express) for styling
 */
const PaymentMethodItem = ({
	                           method,
	                           isSelected,
	                           onSelect,
	                           disabled = false,
	                           cartType = 'normal'
                           }) => {
	const handleClick = () => {
		if (!disabled && onSelect) {
			onSelect(method);
		}
	};

	const handleKeyDown = (e) => {
		if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
			e.preventDefault();
			handleClick();
		}
	};

	return (
		<div
			className={`payment-method-item ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ${cartType}`}
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			role="radio"
			aria-checked={isSelected}
			aria-disabled={disabled}
			tabIndex={disabled ? -1 : 0}
		>
			<div className="payment-method-content">
				<div className="payment-method-icon">
					{method.img_url ? (
						<img src={method.img_url} alt={method.title}/>
					) : (
						<div className="payment-method-icon-placeholder">
							{method.title.charAt(0)}
						</div>
					)}
				</div>

				<div className="payment-method-info">
					<h4 className="payment-method-title">{method.title}</h4>
				</div>
			</div>

			<div className="payment-method-radio">
				<div className={`radio-button ${isSelected ? 'checked' : ''}`}>
					{isSelected && <div className="radio-dot"/>}
				</div>
			</div>
		</div>
	);
};

export default PaymentMethodItem;
